import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NumberNormalizationService {
  normalizeNumberString(inputString: string | null | undefined): string {
    return this.filterJapaneseToArabic(inputString);
  }

  filterJapaneseToArabic(inputString: string | null | undefined): string {
    if (inputString == null) {
      return '';
    }
    const source = String(inputString);
    const japaneseDigits = 'ー．０１２３４５６７８９'.split('');
    const arabicDigits = '-.0123456789'.split('');
    const result: string[] = [];
    for (let i = 0; i < source.length; i++) {
      const index = japaneseDigits.indexOf(source[i]);
      if (index != -1) {
        result.push(arabicDigits[index]);
      } else {
        result.push(source[i]);
      }
    }
    return result.join('');
  }
}
